import React, { useState } from 'react';
import ConfigurationContext from './context';
import type { ConfigurationContextType } from './types';

interface Props {
  children: React.ReactNode;
}

export const ConfigurationProvider = ({ children }: Props) => {
  const [selectedConfiguration, setSelectedonfiguration] =
    useState('REPRESENTATIVE');
  const [showSidebarMenu, setShowSidebarMenu] = useState(true);

  const value: ConfigurationContextType = {
    selectedConfiguration,
    showSidebarMenu,
    setSelectedonfiguration,
    setShowSidebarMenu,
  };

  return (
    <ConfigurationContext.Provider value={value}>
      {children}
    </ConfigurationContext.Provider>
  );
};

export default ConfigurationProvider;
